module.exports = __webpack_public_path__ + "static/media/postakocsi_italiano.d1d86b4d.jpg";